import React from 'react';

interface Props {
  onBack: () => void;
}

export const TalkToTaskPrivacy: React.FC<Props> = ({ onBack }) => {
  return (
    <div className="bg-slate-50 min-h-full font-sans">
      {/* Simple Navigation */}
      <nav className="bg-white border-b border-slate-100 px-6 py-4 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
           <h1 className="font-bold text-xl text-slate-900 tracking-tight">TalkToTask</h1>
           <button onClick={onBack} className="text-sm font-medium text-slate-600 hover:text-slate-900">
             Home
           </button>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="prose prose-slate max-w-none bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-slate-100">
          <h1 className="text-3xl font-extrabold text-slate-900 mb-2">Privacy Policy for TalkToTask</h1>
          <p className="text-sm text-slate-500 mb-8 font-medium">Effective Date: 15th February, 2026</p>
          
          <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-8 text-sm">
              <p className="mb-1"><span className="font-bold text-slate-700">Developer/Owner:</span> Chukwuemeka John Okparaeke</p>
              <p className="mb-0"><span className="font-bold text-slate-700">App Name:</span> TalkToTask</p>
          </div>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">1. Introduction</h2>
          <p>
            "TalkToTask" respects user privacy and is committed to protecting it. The app is a voice-to-task productivity tool that uses Artificial Intelligence to transcribe and organize thoughts.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">2. Information We Collect & Permissions</h2>
          <p>We request the following sensitive permissions for specific functional purposes:</p>
          <ul className="list-disc pl-5 space-y-2 text-slate-700">
            <li><strong>Microphone:</strong> Strictly used to record your voice notes for transcription.</li>
            <li><strong>Speech Recognition:</strong> Used to convert your audio into text.</li>
            <li><strong>Calendar & Reminders:</strong> Used to add your generated tasks and events directly to your device's native calendar and reminders apps at your command.</li>
          </ul>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">3. Data Processing (AI)</h2>
          <p>
            We use <strong>Google Gemini AI</strong> (a third-party service by Google) to process transcriptions and generate summaries.
          </p>
          <p>
            Audio data is sent to this service solely for the purpose of processing your request and is not used to train public models or stored permanently on our external servers.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">4. Data Storage</h2>
          <p>
            Specific user data (transcripts, tasks, and session details) is stored <strong>locally on the user's device</strong> using a local database (Isar). We do not have access to your personal notes or tasks.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">5. Third-Party Services</h2>
          <ul className="list-disc pl-5 space-y-2 text-slate-700">
            <li><strong>RevenueCat:</strong> We use RevenueCat to manage subscriptions and in-app purchases. They may collect anonymous usage data to process transactions.</li>
            <li><strong>Google Gemini API:</strong> For AI processing.</li>
          </ul>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4">6. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact the developer:
          </p>
          <div className="mt-4 p-4 bg-indigo-50 border-l-4 border-indigo-500 rounded-r-lg">
            <p className="font-bold text-indigo-900">Chukwuemeka John Okparaeke</p>
            <p className="text-indigo-800">Email: <a href="mailto:mactrixapp@gmail.com" className="underline hover:text-indigo-600">mactrixapp@gmail.com</a></p>
          </div>
        </div>
        
        <div className="mt-12 text-center pb-8">
            <a href="/" onClick={(e) => { e.preventDefault(); onBack(); }} className="text-slate-500 hover:text-brand-600 font-medium transition-colors border-b border-transparent hover:border-brand-600 pb-0.5">
                ← Back to Home
            </a>
        </div>
      </main>
    </div>
  );
};